import CreditCard from '../SquareCreditCard/CreditCard'

import './style.scss'

// note: make sure this is within a SquarePaymentForm component
const CreditCardForm = ({
  buttonText,
  buttonClassName,
  buttonDisabled,
  ...props
}) => {
  return (
    <>
      <CreditCard
        buttonClassName={buttonClassName}
        buttonText={buttonText}
        buttonDisabled={buttonDisabled}
      />
    </>
  )
}

export default CreditCardForm
